function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "lockedTitle"
}, "locked");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#3e1d78"
}, /*#__PURE__*/React.createElement("path", {
  d: "M350 573.419V594h-26v-20.581h26zm-12.69 6.204c-1.71 0-3.096 1.355-3.096 3.027 0 1.112.613 2.084 1.527 2.61l.175.093v3.35h2.786l.001-3.35c1.01-.498 1.702-1.522 1.702-2.703 0-1.672-1.386-3.027-3.095-3.027zm7.172-16.826c1.232 1.232 1.979 2.736 2.353 4.499.1.472.173.936.223 1.427l.018.186.008.093.015.19.013.194.01.198.01.203.008.207.003.105.005.216.002.11.003.224.001.23v.36l-.003.376-4.744.053.002-.302v-.385l-.003-.187-.003-.181-.005-.177-.005-.173-.007-.168-.009-.165-.01-.16-.01-.156-.012-.152-.014-.149-.015-.145-.017-.14-.009-.07-.019-.135-.02-.133-.01-.064-.023-.128c-.192-1.025-.545-1.725-1.129-2.309-2.068-2.068-5.46-2.03-7.575.085l-.1.101-.094.102-.06.068-.03.034-.057.069-.056.069-.08.105-.05.071c-.042.06-.082.12-.12.182l-.045.075c-.044.075-.086.153-.125.233l-.038.08c-.019.041-.037.083-.054.125l-.035.085-.033.087-.016.045-.03.09-.015.047-.029.094c-.023.079-.045.16-.066.246l-.024.103-.033.16-.021.11-.01.057-.02.115-.017.118-.009.06-.016.124-.015.127-.008.065-.013.133-.013.136-.012.14-.01.145-.01.149-.01.152-.008.158-.004.08-.01.247-.007.171-.007.266-.007.276-.003.191-.004.296-4.744.053.004-.335.003-.215.007-.309.007-.295.006-.189.01-.273.008-.175.009-.17.01-.166.015-.241.018-.233.014-.15.014-.148.016-.144.017-.142.017-.14.02-.139.02-.136.022-.135.023-.135.025-.133.026-.133.028-.134.03-.133.03-.134c.401-1.702 1.18-3.148 2.451-4.42 3.99-3.99 10.385-4.06 14.286-.16z",
  transform: "translate(-324 -559)"
})));

var SvgPrimaryButtonUiLockedIcon = function SvgPrimaryButtonUiLockedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    "aria-labelledby": "lockedTitle",
    role: "img",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "lockedTitle"
  }, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrimaryButtonUiLockedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/primary-button-ui-locked-icon.6a41c13e.svg";
export { ForwardRef as ReactComponent };